import { Component, Input, ViewEncapsulation } from '@angular/core';
import {LoyaltyMode, LoyaltyService} from '@shopping-angular-components/loyalty';
import { LandingModel } from 'projects/common/model/landingModel';
import { LandingModelService } from 'projects/common/services/landingModel.service';

interface LoyaltyInfo {
  accrual_points: number;
}

@Component({
  selector: 'loyalty-offer-info',
  template: `
    <div class="offer-card-loyalty-info" *ngIf="loyaltyInfo && loyaltyInfo.accrual_points">
      <loyalty-info
        [product]="'nymeria-gui'"
        [flow]="flow"
        [loyaltyMode]="loyaltyMode!"
        [locale]="locale"
        [points]="loyaltyInfo.accrual_points"
        [disableExplanationNotice]="true"
        [mainMessageInColumn]="true"
        [thousandsSeparator]="thousandsSeparator"
      >
      </loyalty-info>
    </div>
<!--    TODO ESTA PARTE DEL COMPONENTE ES PROVISORIO HASTA QUE TODOS LOS PRODUCTOS TRAIGAN PUNTOS DE LOYALTY -->
    <div class="offer-card-loyalty-info -old" *ngIf="isDespegar && loyaltyInfo && !loyaltyInfo.accrual_points">
      <div class="eva-3-pricing-points -border-top -wrapper-padding -border-radius-bottom">
        <img class="pricing-points-logo" src="https://www.staticontent.com/eva-core/assets/logos/0.0.1/loyalty-logo.svg" loading="lazy" alt="loyalty logo">
        <div class="main-message-in-column">
          <span class="program-color -eva-3-bold -eva-3-mr-xsm">
            <span>{{'offers.loyalty.passport' | translate}}</span>
          </span>
          <span class="capitalized-message">
            <span>{{'offers.loyalty.acquisition' | translate}}
              <span class="-eva-3-bold">{{'offers.loyalty.points' | translate}}</span>
            </span>
          </span>
        </div>
      </div>
    </div>
<!--    TODO ESTA PARTE DEL COMPONENTE ES PROVISORIO HASTA QUE TODOS LOS PRODUCTOS TRAIGAN PUNTOS DE LOYALTY -->
  `,
  styleUrls: ['./loyalty-offer-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoyaltyOfferInfoComponent {
  @Input() loyaltyInfo: LoyaltyInfo;
  @Input() locale: string;
  @Input() loyaltyMode: LoyaltyMode | null = LoyaltyMode.COUNTRY_OFF;
  @Input() product;
  @Input() flow;

  isDespegar: any;
  thousandsSeparator: string;

  constructor(private landingModelService: LandingModelService) {
    const landingModel: LandingModel = this.landingModelService.getLandingModel();
    this.isDespegar = landingModel.partner == null;
    this.thousandsSeparator = landingModel.keywordsMap['THOUSAND_SEPARATOR'];
  }
}
